<template>
  <div
    class="boxBig"
    v-loading="loading"
    :element-loading-text="loadingTitle"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- <div class="selectTop mgb-10">
      <div
        :class="selectActive === v.id ? 'selectActive' : 'select'"
        v-for="v in selectArr"
        :key="v.id"
        @click="changeSelect(v.id)"
      >
        {{ v.name }}
      </div>
    </div> -->
    <!-- 表单查询 -->
    <div class="bg-white pd-10">
      <el-form :inline="true" ref="form" :model="form" label-width="100px">
        <el-form-item label="水卡编号">
          <el-input
            v-model="form.cardId"
            clearable
            placeholder="请输入水卡编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户昵称">
          <el-input
            v-model="form.customerName"
            clearable
            placeholder="请输入用户昵称"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户电话">
          <el-input
            v-model="form.customerPhone"
            clearable
            placeholder="请输入用户电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="水卡状态">
          <el-select v-model="form.cardStatus" placeholder="全部" clearable>
            <el-option label="正常" value="0"></el-option>
            <el-option label="已挂失" value="1"></el-option>
            <el-option label="异常" value="2"></el-option>
            <!-- <el-option label="已失效" value="3"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="所属分区">
          <el-select v-model="form.fenqu" placeholder="全部" clearable>
            <el-option
              v-for="(v, i) in fenquArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" ref="form" :model="form" label-width="100px">
        <el-form-item label="水卡类型">
          <el-select v-model="form.cardType" placeholder="全部" clearable>
            <el-option label="实物卡" value="2"></el-option>
            <el-option label="电子卡" value="1"></el-option>
            <!-- <el-option label="时效电子卡" value="3"></el-option>
            <el-option label="时效实物卡" value="4"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="是否绑定">
          <el-select v-model="form.status" placeholder="全部" clearable>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="水卡管理员">
          <el-select v-model="form.userName" placeholder="全部" clearable>
            <el-option
              v-for="(v, i) in userArr"
              :key="i"
              :label="v.name"
              :value="v.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="绑定时间">
          <el-date-picker
            v-model="form.bindStartTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.bindEndTime"
            :picker-options="pickerOptionsEnd13"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chaxun">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 统计 -->
    <div class="color052173 f16 mgt-20 mgb-5">
      <span class="mgl-15 mgr-35">水卡总数（张）：{{ cardDetail.total }}</span>

      <span class=" mgr-35">普通实物卡（张）：{{ cardDetail.entityNum }}</span>
      <!-- <span class=" mgr-35"
        >时效实物卡（张）：{{ cardDetail.timeEntityNum }}</span
      > -->
      <span class=" mgr-35">普通电子卡（张）：{{ cardDetail.waterNum }}</span>
      <!-- <span class=" mgr-35"
        >时效电子卡（张）：{{ cardDetail.timeWaterNum }}</span
      > -->
    </div>
    <!-- = -->
    <div class="flex aic">
      <btns class="mgb-20" @exec="exec"></btns>
      <!-- <el-button size="small" class="mgl-10" @click="export2">导出</el-button> -->
    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column v-if="roleId !== 23" type="selection" width="55">
      </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="cardId" label="水卡编号"> </el-table-column>
      <el-table-column prop="cardType" label="水卡类型">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardType == 2
                ? '实物卡'
                : scope.row.cardType == 1
                ? '电子卡'
                : scope.row.cardType == 3
                ? '时效电子卡'
                : scope.row.cardType == 4
                ? '时效实物卡'
                : '--'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="regionName" label="所属分区">
        <template slot-scope="scope">
          <span
            v-text="scope.row.regionName ? scope.row.regionName : '- -'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="水卡创建时间">
      </el-table-column>
      <el-table-column prop="updateTime" label="水卡绑定时间">
      </el-table-column>
      <el-table-column prop="status" label="是否绑定">
        <template slot-scope="scope">
          <span v-text="scope.row.status == 1 ? '是' : '否'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="cardName" label="用户昵称">
        <template slot-scope="scope">
          <span v-text="scope.row.cardName ? scope.row.cardName : '--'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="customerPhone" label="客户电话">
        <template slot-scope="scope">
          <span
            v-text="scope.row.customerPhone ? scope.row.customerPhone : '--'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="cardStatus" label="水卡状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardStatus == 0
                ? '正常'
                : scope.row.cardStatus == 1
                ? '已挂失'
                : scope.row.cardStatus == 2
                ? '异常'
                : '已失效'
            "
          ></span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="companyName" label="归属企业">
        <template slot-scope="scope">
          <span
            v-text="scope.row.companyName ? scope.row.companyName : '--'"
          ></span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="sourceName" label="水卡来源">
        <template slot-scope="scope">
          <span
            v-text="scope.row.sourceName ? scope.row.sourceName : '--'"
          ></span>
        </template>
      </el-table-column> -->
      <el-table-column prop="cardStatus" label="是否显示">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.deleteStatus == 0
                ? '是'
                : scope.row.deleteStatus == 1
                ? '否'
                : ''
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="sourceName" label="水卡管理员">
        <template slot-scope="scope">
          <span v-text="scope.row.userName ? scope.row.userName : '--'"></span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleGoDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 水卡绑定弹框 -->
    <el-dialog
      title="水卡绑定"
      :visible.sync="bindVisible"
      width="30%"
      @close="bindForm = {}"
      center
      :close-on-click-modal="false"
    >
      <el-form
        ref="bindForm"
        :rules="bindFormRules"
        :model="bindForm"
        label-width="80px"
      >
        <el-form-item label="水卡编号">
          <el-input v-model="bindForm.num" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input
            v-model="bindForm.user"
            placeholder="请输入用户昵称"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户电话" prop="phone">
          <el-input
            v-model="bindForm.phone"
            placeholder="请输入水卡绑定客户电话"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="bindVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindBtn('bindForm')"
          >水卡绑定</el-button
        >
      </span>
    </el-dialog>

    <!-- 分配员工弹框 -->
    <el-dialog
      title="分配员工"
      :visible.sync="staffVisible"
      width="30%"
      :close-on-click-modal="false"
      center
      top="40vh"
    >
      <el-form
        ref="staffForm"
        :rules="staffRules"
        :model="staffForm"
        label-width="120px"
      >
        <el-form-item label="水卡编号" v-if="multipleSelection.length === 1">
          <el-input :disabled="true" v-model="staffForm.cardId"></el-input>
        </el-form-item>
        <el-form-item label="水卡编号" v-if="multipleSelection.length > 1">
          <el-input
            :disabled="true"
            type="textarea"
            v-model="staffForm.cardId"
          ></el-input>
        </el-form-item>
        <el-form-item label="水卡管理员工" prop="staff">
          <el-select v-model="staffForm.staff" placeholder="请选择水卡管理员工">
            <el-option
              v-for="(v, i) in userArr"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="staffVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="staffSure('staffForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 水卡解绑弹框 -->
    <el-dialog
      title="解绑"
      :visible.sync="jiebangVisible"
      width="30%"
      :close-on-click-modal="false"
      center
      top="40vh"
    >
      <div class="mgb-10 center">
        水卡解绑后绑定用户信息将重置，确定解绑水卡吗？
      </div>
      <el-form
        ref="jiebangForm"
        :rules="jiebangFormRules"
        :model="jiebangForm"
        label-width="80px"
      >
        <el-form-item label="备注" prop="desc">
          <el-input
            maxlength="30"
            show-word-limit
            placeholder="请输入备注说明"
            type="textarea"
            v-model="jiebangForm.desc"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="jiebangVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="jiebangSure('jiebangForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 水卡清零弹框 -->
    <el-dialog
      title="水卡清零"
      :visible.sync="qinglingVisible"
      width="30%"
      :close-on-click-modal="false"
      center
      top="40vh"
    >
      <!-- <div class="mgb-10 center">
        确认将水卡余额清零吗？
      </div> -->
      <el-form
        ref="qinglingForm"
        :rules="qinglingFormRules"
        :model="qinglingForm"
        label-width="80px"
      >
        <el-form-item label="申请备注" prop="desc">
          <el-input
            maxlength="100"
            show-word-limit
            placeholder="请输入备注说明"
            type="textarea"
            v-model="qinglingForm.desc"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请图片">
          <!-- 申请图片 -->
          <el-upload
            class="avatar-uploader"
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="qinglingForm.imgList"
            :http-request="uploadFile"
            :limit="3"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="imgsVisible">
            <img width="100%" :src="imgs" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <div style="color: red;">
        温馨提示：提交申请后需由销售部与财务部工作人员审核，审核通过系统将自动对水卡余额进行清零，若用户需退款请走退款流程。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="qinglingVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="qinglingSure('qinglingForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 登录密码确认弹框 -->
    <el-dialog
      :title="'密码确认'"
      :visible.sync="pwdSureVisible"
      width="20%"
      top="50vh"
      center
      :close-on-click-modal="false"
    >
      <el-form ref="pwdForm" :model="pwdForm" label-width="80px" inline>
        <el-form-item
          label="登录密码"
          prop="password"
          :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
        >
          <el-input
            show-password
            v-model="pwdForm.password"
            placeholder="请输入登录密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pwdSureVisible = false">取 消</el-button>
        <el-button type="primary" @click="pwdSure('pwdForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 导出弹框 -->

    <el-dialog
      title="导出"
      :visible.sync="exportVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      top="35vh"
    >
      <div class="mgb-10">温馨提示:不填写条件则导出全部</div>

      <el-form
        ref="exportForm"
        :model="exportForm"
        label-width="80px"
      >
        <el-form-item label="所属分区">
          <el-select
            v-model="exportForm.fenqu"
            placeholder="全部"
            filterable
            clearable
          >
            <el-option
              v-for="(v, i) in fenquArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="水卡类型">
          <el-select v-model="exportForm.cardType" placeholder="全部" clearable>
            <el-option label="电子卡" value="1"></el-option>
            <el-option label="实物卡" value="2"></el-option>
            <el-option label="时效电子卡" value="3"></el-option>
            <el-option label="时效实物卡" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="水卡状态">
          <el-select
            v-model="exportForm.cardStatus"
            placeholder="全部"
            clearable
          >
            <el-option label="正常" value="0"></el-option>
            <el-option label="已挂失" value="1"></el-option>
            <el-option label="异常" value="2"></el-option>
            <el-option label="已失效" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否綁定">
          <el-select v-model="exportForm.status" placeholder="全部" clearable>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间">
          <div class="flex">
            <el-date-picker
              v-model="exportForm.startTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            至
            <el-date-picker
              :disabled="!exportForm.startTime"
              v-model="exportForm.endTime"
              :picker-options="pickerOptionsEnd8"
              format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="绑定时间">
          <div class="flex">
            <el-date-picker
              v-model="exportForm.bindStartTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            至
            <el-date-picker
              :disabled="!exportForm.bindStartTime"
              v-model="exportForm.bindEndTime"
              :picker-options="pickerOptionsEnd18"
              format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="exportBtnSure('exportForm')"
          >导 出</el-button
        >
      </span>
    </el-dialog>

    <!-- 导出选择数据弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportChangeNumVisible"
      width="50%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <el-descriptions column="5" border title="请选择需要导出的数据">
        <el-descriptions-item v-for="(v, i) in radioArr" :key="i" label="范围">
          <el-radio v-model="radio" :label="v.id" @input="changeRadioInput">{{
            v.start + "-" + v.end + "条"
          }}</el-radio></el-descriptions-item
        >
      </el-descriptions>

      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportChangeNumVisible = false"
          >关 闭</el-button
        >
        <el-button type="primary" @click="exportNumBtn">导 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import store from "../../store";

export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    // 新增联系方式验证
    const bindPhone = (rule, value, callback) => {
      var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!value) {
        callback(new Error("请填写客户电话"));
      } else if (!reg.test(value)) {
        callback(new Error("手机号格式不正确，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsEnd13: {
        disabledDate: (time) => {
          let beginDateVal = this.form.bindStartTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },

      pickerOptionsEnd8: {
        disabledDate: (time) => {
          let beginDateVal = this.exportForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },

      pickerOptionsEnd18: {
        disabledDate: (time) => {
          let beginDateVal = this.exportForm.bindStartTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      selectArr: [
        { id: 1, name: "未来先生" },
        { id: 2, name: "未来先生一" },
      ],
      pwdSureVisible: false,
      pwdForm: {
        password: "",
      },
      jiebangVisible: false,
      jiebangForm: { desc: "" },
      qinglingVisible: false,
      qinglingForm: { desc: "", imgList: [] },

      selectActive: 1,
      form: {},
      tableData: [],
      staffVisible: false,
      multipleSelection: [],
      bindVisible: false,
      bindForm: {},
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 15, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      bindFormRules: {
        phone: [{ required: true, validator: bindPhone, trigger: "blur" }],
      },
      rechargeReal: 0,
      actual: 0,
      undetermined: 0,
      guishuqiye: [],
      roleId: null,
      staffForm: {
        cardId: "",
        staff: "",
      },
      loading: false,
      loadingTitle: "数据加载中",
      staffRules: {
        staff: [
          { required: true, message: "请选择水卡管理员工", trigger: "blur" },
        ],
      },
      jiebangFormRules: {
        desc: [{ required: true, message: "请输入备注说明", trigger: "blur" }],
      },
      qinglingFormRules: {
        desc: [{ required: true, message: "请输入备注说明", trigger: "blur" }],
      },
      userArr: [],
      type: null,
      fenquArr: [],
      cardDetail: {},
      exportVisible: false,
      exportForm: {
        guishu: [],
        cardType: "",
        startTime: "",
        endTime: "",
        cardStatus: "",
        status: "",
        bindStartTime: "",
        bindEndTime: "",
      },
      radio: "1",
      radioArr: [],
      exportChangeNumVisible: false,
      exportNum: null,
      interval: 2000,
      imgsVisible: false,
      imgs: "",
      companyId: null,
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },

    "form.bindStartTime"() {
      if (this.form.bindStartTime == null) {
        this.form.bindEndTime = null;
      }
    },
    "exportForm.startTime"() {
      if (this.exportForm.startTime == null) {
        this.exportForm.endTime = null;
      }
    },

    "exportForm.bindStartTime"() {
      if (this.exportForm.bindStartTime == null) {
        this.exportForm.bindEndTime = null;
      }
    },
  },
  created() {
    this.getcardList();
    // this.getStat();
    this.getGuishu();
    this.getROLE();
    this.getUserPull();
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1500);
    this.getFenqu();
    this.getCardDetail();
  },
  methods: {
    export2() {
      this.export();
    },
    // 水卡清零申请图片上传

    // 凭证图片上传------
    handlePictureCardPreview(file) {
      this.imgs = file.url;
      this.imgsVisible = true;
    },
    handleRemove(file, fileList) {
      this.qinglingForm.imgList = fileList;
    },
    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then((res) => {
        if (res.code === 200) {
          console.log(res.data, "res.data");

          // this.stageTreeForm.equipmentPhoto = URL.createObjectURL(params.file);
          // this.changeHeadImgform.headUrl = res.data[0];
          this.imgs = res.data[0];
          this.qinglingForm.imgList.push({
            url: res.data[0],
          });
          // this.imgList.forEach((v) => {
          //   console.log(v, "哦哦哦");
          //   this.imgListUpload.push(v.url);
          // });
          // this.imgListUpload = this.imgListUpload.filter(
          //   (item, index, array) => {
          //     return array.indexOf(item) === index;
          //   }
          // );
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },
    // 图片超出张数不显示上传框
    handleEditChange(file, fileList) {
      console.log(fileList, "fileList");
      console.log(this.limitCount, "this.limitCount");
      // this.hideUpload = fileList.length >= 1;
      // if (fileList.length === 1) {
      //   this.$refs.upload.clearFiles(); // 清空上传文件列表
      //   this.$refs.upload.uploadFiles = []; // 清空已上传的文件列表
      //   this.$refs.upload.fileList = []; // 清空已上传的文件列表
      // }
    },

    export() {
      this.exportVisible = true;
      this.exportForm = {
        fenqu: "",
        cardType: "",
        startTime: "",
        endTime: "",
        status: "",
        cardStatus: "",
        bindStartTime: "",
        bindEndTime: "",
      };
    },
    exportNumBtn() {
      if (!this.radio) {
        handleAlert("请选择条数范围", "error");
        return;
      }
      let page = null;
      this.radioArr.forEach((v, i) => {
        if (this.radio == v.id) {
          this.exportForm.limitStart = v.start;
          this.exportForm.limitEnd = v.end;
          page = i + 1;
        }
      });
      handleConfirm("确认导出吗?", "info")
        .then(() => {
          this.$api.waterCard
            .cardExport({
              regionId: this.exportForm.fenqu,
              //  sourceName: this.selectActive == 1 ? "未来先生" : "未来先生一",
              type: this.exportForm.cardType ? this.exportForm.cardType : null,
              startTime: this.exportForm.startTime
                ? this.exportForm.startTime
                : null,
              endTime: this.exportForm.endTime ? this.exportForm.endTime : null,
              status: this.exportForm.status ? this.exportForm.status : null,
              cardStatus: this.exportForm.cardStatus
                ? this.exportForm.cardStatus
                : null,
              pageNum: page,
              pageSize: this.interval,
              bindStartTime: this.exportForm.bindStartTime
                ? this.exportForm.bindStartTime
                : null,
              bindEndTime: this.exportForm.bindEndTime
                ? this.exportForm.bindEndTime
                : null,
            })
            .then((res) => {
              handleAlert("导出成功", "success");
              // this.exportChangeNumVisible = false;
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(res);
              link.setAttribute("download", `水卡列表.xls`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
        })
        .catch(() => {
          return;
        });
    },
    // 导出
    exportBtnSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          // if (!this.exportForm.startTime || !this.exportForm.endTime) {
          //   handleAlert("请选择时间范围", "warning");
          //   return;
          // }
          this.$api.waterCard
            .cardExportNum({
              regionId: this.exportForm.fenqu,
              //    sourceName: this.selectActive == 1 ? "未来先生" : "未来先生一",
              cardType: this.exportForm.cardType
                ? this.exportForm.cardType
                : null,
              startTime: this.exportForm.startTime
                ? this.exportForm.startTime
                : null,
              endTime: this.exportForm.endTime ? this.exportForm.endTime : null,
              status: this.exportForm.status ? this.exportForm.status : null,
              cardStatus: this.exportForm.cardStatus
                ? this.exportForm.cardStatus
                : null,
              bindStartTime: this.exportForm.bindStartTime
                ? this.exportForm.bindStartTime
                : null,
              bindEndTime: this.exportForm.bindEndTime
                ? this.exportForm.bindEndTime
                : null,
            })
            .then((a) => {
              console.log(a, "aa");

              if (a.code === 200) {
                if (Number(a.data) > this.interval) {
                  console.log(666);

                  this.radioArr = []; // 清空之前的范围
                  let id = 1; // 从1开始递增的ID
                  for (let i = 0; i < a.data; i += this.interval) {
                    const end = Math.min(i + this.interval - 1, a.data - 1);
                    this.radioArr.push({ id, start: i + 1, end: end + 1 });
                    id++;
                  }
                  this.exportVisible = false;
                  this.radio = "";
                  this.exportChangeNumVisible = true;
                } else {
                  handleConfirm("确认导出吗?", "info")
                    .then(() => {
                      this.$api.waterCard
                        .cardExport({
                          regionId: this.exportForm.fenqu,
                          // sourceName:
                          // this.selectActive == 1 ? "未来先生" : "未来先生一",
                          type: this.exportForm.cardType
                            ? this.exportForm.cardType
                            : null,
                          startTime: this.exportForm.startTime
                            ? this.exportForm.startTime
                            : null,
                          endTime: this.exportForm.endTime
                            ? this.exportForm.endTime
                            : null,
                          status: this.exportForm.status
                            ? this.exportForm.status
                            : null,
                          cardStatus: this.exportForm.cardStatus
                            ? this.exportForm.cardStatus
                            : null,
                          pageNum: 1,
                          pageSize: a.data,
                          bindStartTime: this.exportForm.bindStartTime
                            ? this.exportForm.bindStartTime
                            : null,
                          bindEndTime: this.exportForm.bindEndTime
                            ? this.exportForm.bindEndTime
                            : null,
                        })
                        .then((res) => {
                          this.exportVisible = false;
                          const link = document.createElement("a");
                          link.style.display = "none";
                          link.href = URL.createObjectURL(res);
                          link.setAttribute("download", "水卡列表.xls");
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          handleAlert("导出成功", "success");
                        });
                    })
                    .catch(() => {
                      return;
                    });
                }
              }
            });
        } else {
          return false;
        }
      });
    },
    getCardDetail() {
      this.$api.waterCard
        .cardListStat({
          cardId: this.form.cardId,
          cardName: this.form.customerName,
          customerPhone: this.form.customerPhone,
          cardType: this.form.cardType,
          cardStatus: this.form.cardStatus,
          status: this.form.status,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          companyName: this.form.guishu,
          userName: this.form.userName,
          regionId: this.form.fenqu,
          bindStartTime: this.form.bindStartTime,
          bindEndTime: this.form.bindEndTime,
        })
        .then((res) => {
          if (res.code === 200) {
            console.log(res, "统计");

            this.cardDetail = res.data;
          }
        });
    },
    timeCard() {
      this.$router.push("/waterCard/cardList/timeCard");
    },
    // 分区下拉
    getFenqu() {
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.fenquArr = res.data;
        }
      });
    },
    // 密码确认
    pwdSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.$api.shebei
            .pwdNotarize({ password: this.pwdForm.password })
            .then((res) => {
              if (res.data === "密码错误!") {
                handleAlert("密码错误，请重新输入", "error");
                this.pwdForm = {};
              } else {
                if (this.type === "解绑") {
                  this.pwdSureVisible = false;
                  this.jiebangForm = { desc: "" };
                  this.jiebangVisible = true;
                  this.$nextTick(() => {
                    //清楚表单内容
                    this.$refs.jiebangForm.clearValidate();
                  });
                } else {
                  this.pwdSureVisible = false;
                  this.qinglingForm = { desc: "", imgList: [] };
                  this.qinglingVisible = true;
                  this.$nextTick(() => {
                    //清楚表单内容
                    this.$refs.qinglingForm.clearValidate();
                  });
                }
              }
            });
        } else {
          return false;
        }
      });
    },
    // 水卡清零
    cardReset() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      let arr = [];
      this.multipleSelection.forEach((v) => {
        if (v.sourceName == "未来先生一") {
          arr.push(v);
        }
      });
      // if (arr.length > 0) {
      //   handleAlert("未来先生一水卡不支持清零,请重新选择", "error");
      //   return;
      // }
      // this.qinglingForm = { desc: "" };
      // this.qinglingVisible = true;
      // this.$nextTick(() => {
      //   //清楚表单内容
      //   this.$refs.qinglingForm.clearValidate();
      // });
      this.type = "清零";
      this.pwdSureVisible = true;
      this.pwdForm = { password: "" };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.pwdForm.clearValidate();
      });
    },
    // 解绑
    unbind() {
      if (this.multipleSelection.length === 0) {
        handleAlert("请选择数据", "error");
        return;
      }
      let arr = [];
      let arrClass = [];
      let timeCard = [];
      this.multipleSelection.forEach((v) => {
        if (v.status !== 1) {
          arr.push(v);
        } else if (v.cardType == 1) {
          arrClass.push(v);
        } else if (v.cardType == 3 || v.cardType == 4) {
          timeCard.push(v);
        }
      });
      if (arrClass.length > 0) {
        handleAlert("电子卡暂不支持解绑,请重新选择", "error");
        return;
      }
      if (timeCard.length > 0) {
        handleAlert("时效卡暂不支持解绑,请重新选择", "error");
        return;
      }
      if (arr.length > 0) {
        handleAlert("存在水卡未绑定,请勿重复操作", "error");
        return;
      }
      // this.jiebangForm = { desc: "" };
      // this.jiebangVisible = true;
      // this.$nextTick(() => {
      //   //清楚表单内容
      //   this.$refs.jiebangForm.clearValidate();
      // });
      this.type = "解绑";
      this.pwdSureVisible = true;
      this.pwdForm = { password: "" };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.pwdForm.clearValidate();
      });
    },
    qinglingSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认提交水卡清零申请吗?", "info")
            .then(() => {
              let arr = [];
              this.multipleSelection.forEach((v) => {
                arr.push(v.cardId);
              });
              let imgArr = [];
              this.qinglingForm.imgList.forEach((v) => {
                imgArr.push(v.url);
              });
              this.$api.waterCard
                .qingling({
                  card: this.multipleSelection[0].cardId,
                  remark: this.qinglingForm.desc,
                  remarkImg: imgArr,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("申请已提交", "success");
                    this.qinglingForm = { desc: "", imgList: [] };
                    this.qinglingVisible = false;
                    this.getcardList();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    jiebangSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认解绑该水卡吗?", "info")
            .then(() => {
              let arr = [];
              this.multipleSelection.forEach((v) => {
                arr.push({
                  cardId: v.id,
                  customerPhone: v.customerPhone,
                });
              });
              this.$api.waterCard
                .jiebang({ cardList: arr, remark: this.jiebangForm.desc })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("解绑成功", "success");
                    this.jiebangVisible = false;

                    this.getcardList();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    staffSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认保存吗?", "info")
            .then(() => {
              let arr = [];
              this.multipleSelection.forEach((v) => {
                arr.push({
                  id: v.id,
                  userId: this.staffForm.staff,
                });
              });
              this.$api.waterCard.fenStaff(arr).then((res) => {
                if (res.code === 200) {
                  this.staffVisible = false;
                  handleAlert("保存成功", "success");

                  this.getcardList();
                }
              });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    getUserPull() {
      this.$api.waterCard.userPull().then((res) => {
        if (res.code === 200) {
          this.userArr = res.data.list;
        }
      });
    },
    // lostCard(row) {
    //   handleConfirm("是否挂失该水卡?", "info")
    //     .then(() => {
    //       this.$api.waterCard
    //         .hptLost({ cardId: row.cardId, status: "lost" })
    //         .then((res) => {
    //           if (res.code === 200) {
    //             handleAlert("水卡已挂失", "success");
    //             this.gethptList();
    //           }
    //         });
    //     })
    //     .catch(() => {
    //       return;
    //     });
    // },
    // noLostCard(row) {
    //   handleConfirm("是否解除该水卡挂失?", "info")
    //     .then(() => {
    //       this.$api.waterCard
    //         .hptLost({ cardId: row.cardId, status: "normal" })
    //         .then((res) => {
    //           if (res.code === 200) {
    //             handleAlert("挂失已解除", "success");
    //             this.gethptList();
    //           }
    //         });
    //     })
    //     .catch(() => {
    //       return;
    //     });
    // },

    // 挂失
    report() {
      if (this.multipleSelection.length === 0) {
        handleAlert("请选择数据", "error");
        return;
      }

      // let sourceArr = [];
      // this.multipleSelection.forEach((v) => {
      //   if (sourceArr.indexOf(v.sourceArr) === -1) {
      //     sourceArr.push(v.sourceName);
      //   }
      // });
      // if (sourceArr.length > 0) {
      //   handleAlert("机器来源不一致,请重新选择", "error");
      //   return;
      // }

      let cardTypeArr = [];
      this.multipleSelection.forEach((v) => {
        if (v.cardType !== 2 && v.cardType !== 4) {
          cardTypeArr.push(v);
        }
      });
      if (cardTypeArr.length > 0) {
        handleAlert("电子卡无法挂失,请重新选择", "error");
        return;
      }
      let cardStatusArr = [];
      this.multipleSelection.forEach((v) => {
        if (v.cardStatus !== 0) {
          cardStatusArr.push(v);
        }
      });
      if (cardStatusArr.length > 0) {
        handleAlert("水卡存在已挂失或异常水卡,请重新选择", "error");
        return;
      }
      let cardIdArr = [];
      this.multipleSelection.forEach((v) => {
        cardIdArr.push({
          id: v.id,
          cardId: v.cardId,
          lostStatus: "lost",
          sourceName: v.sourceName,
        });
      });
      handleConfirm("是否挂失该水卡?", "info")
        .then(() => {
          this.$api.waterCard.hptLost(cardIdArr).then((res) => {
            if (res.code === 200) {
              handleAlert("水卡已挂失", "success");
              this.getcardList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    // 解除挂失
    relieve() {
      if (this.multipleSelection.length === 0) {
        handleAlert("请选择数据", "error");
        return;
      }
      // let sourceArr = [];
      // this.multipleSelection.forEach((v) => {
      //   if (v.sourceName !== "未来先生一") {
      //     sourceArr.push(v);
      //   }
      // });
      // if (sourceArr.length > 0) {
      //   handleAlert("请选择未来先生一机器", "error");
      //   return;
      // }
      let cardStatusArr = [];
      this.multipleSelection.forEach((v) => {
        if (v.cardStatus !== 1) {
          cardStatusArr.push(v);
        }
      });
      if (cardStatusArr.length > 0) {
        handleAlert("水卡存在正常卡或异常水卡,请重新选择", "error");
        return;
      }
      let cardIdArr = [];
      this.multipleSelection.forEach((v) => {
        cardIdArr.push({
          id: v.id,
          cardId: v.cardId,
          lostStatus: "normal",
          sourceName: v.sourceName,
        });
      });
      handleConfirm("是否解除该水卡的挂失?", "info")
        .then(() => {
          this.$api.waterCard.hptLost(cardIdArr).then((res) => {
            if (res.code === 200) {
              handleAlert("水卡已解除挂失", "success");
              this.getcardList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    changeSelect(a) {
      this.selectActive = a;
      if (this.selectActive === 1) {
        this.getcardList();
      } else {
        this.gethptList();
      }
    },
    staffTo() {
      // if (this.multipleSelection.length === 0) {
      //   handleAlert("请选择数据", "error");
      //   return;
      // }
      // let cardIdArr = [];
      // this.multipleSelection.forEach((v) => {
      //   cardIdArr.push(v.cardId);
      // });
      // this.staffForm.cardId = cardIdArr.join(",");
      // this.staffForm.staff = "";
      // this.staffVisible = true;
      // this.$nextTick(() => {
      //   //清楚表单内容
      //   this.$refs.staffForm.clearValidate();
      // });
      this.$router.push("/waterCard/cardList/fenPeople");
    },
    chaxun() {
      this.getcardList();
      this.getCardDetail();
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.roleId = token.roleId;
        this.companyId = token.companyId;
      }
    },
    getGuishu() {
      this.$api.waterCard.enterpriseListPullNew().then((res) => {
        this.guishuqiye = res.data;
      });
    },
    getStat() {
      this.$api.waterCard.orderStatistics().then((res) => {
        if (res.code == 200) {
          this.rechargeReal = (
            res.data.rechargeReal + res.data.rechargeGive
          ).toFixed(2);
          this.actual = (res.data.consumeGive + res.data.consumeReal).toFixed(
            2
          );
          this.undetermined = (this.rechargeReal - this.actual).toFixed(2);
        }
      });
    },

    bind() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      if (!this.multipleSelection[0].regionName) {
        handleAlert("该水卡未划分区域,无法绑定", "error");
        return;
      }
      if (this.multipleSelection[0].status === 1) {
        handleAlert("该水卡已绑定，请重新选择", "error");
        return;
      }
      if (!this.multipleSelection[0].regionName) {
        handleAlert("水卡未划分区域，无法绑定用户", "error");
        return;
      }
      this.bindForm.num = this.multipleSelection[0].cardId;
      this.bindVisible = true;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.bindForm.clearValidate();
      });
    },

    getcardList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.waterCard
        .listAll({
          pageNum: this.page,
          pageSize: this.pageSize,
          cardId: this.form.cardId,
          cardName: this.form.customerName,
          customerPhone: this.form.customerPhone,
          cardType: this.form.cardType,
          cardStatus: this.form.cardStatus,
          status: this.form.status,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          companyName: this.form.guishu,
          userName: this.form.userName,
          regionId: this.form.fenqu,
          bindStartTime: this.form.bindStartTime,
          bindEndTime: this.form.bindEndTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
            // const phoneReg = /^(\d{3})\d{4}(\d{4})$/;
            // this.tableData.forEach((v) => {
            //   if (v.customerPhone) {
            //     v.customerPhone = v.customerPhone.replace(phoneReg, "$1****$2");
            //   }
            // });
          }
        });
    },

    gethptList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.waterCard
        .hptList({
          pageNum: this.page,
          pageSize: this.pageSize,
          cardId: this.form.cardId,
          customerName: this.form.customerName,
          customerPhone: this.form.customerPhone,
          cardType: this.form.cardType,
          cardStatus: this.form.cardStatus,
          status: this.form.status,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          companyName: this.form.guishu,
          userName: this.form.userName,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },

    // 绑定弹框
    bindBtn(f) {
      this.$refs[f].validate((valid) => {
        if (valid) {
          handleConfirm(
            `确认将水卡绑定至用户（${this.bindForm.phone}）吗？`,
            "info"
          )
            .then(() => {
              this.$api.waterCard
                .cardBind({
                  cardName: this.bindForm.user,
                  cardNum: this.bindForm.num,
                  phone: this.bindForm.phone,
                  id: this.multipleSelection[0].id,
                  userCardId: this.multipleSelection[0].userCardId,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("绑定成功", "success");
                    this.bindVisible = false;

                    this.getcardList();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    handleGoDetail(row) {
      this.$router.push({
        path: "/waterCard/cardList/cardDetail",
        query: {
          data: row,
        },
      });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    // 删除
    del() {
      if (this.multipleSelection.length !== 1) {
        this.$message.error("请选择一张水卡");
        return;
      }
      if (this.multipleSelection[0].status == 1) {
        this.$message.error("已绑定的水卡无法删除");
        return;
      }
      if (this.multipleSelection[0].cardType == 1) {
        this.$message.error("电子卡无法删除");
        return;
      }
      handleConfirm(`确认删除该水卡吗？`, "info")
        .then(() => {
          this.$api.waterCard
            .cardDel({ cardNo: this.multipleSelection[0].cardId })
            .then((res) => {
              if (res.code === 200) {
                handleAlert("水卡已删除", "success");

                this.getcardList();
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    openCard() {
      this.$router.push("/waterCard/cardList/cardOpen");
    },
    top() {
      this.$router.push("/waterCard/cardList/cardTop");
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;

      this.getcardList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;

      this.getcardList(this.page);
    },
    reset() {
      this.form = { startTime: "", endTime: "" };

      this.getcardList();
      this.getCardDetail();
    },
  },
};
</script>

<style lang="scss" scoped>
.selectTop {
  display: flex;
  justify-content: center;
  .select {
    width: 30%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: var(--card-bg);
    cursor: pointer;
  }
  .selectActive {
    width: 30%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: var(--accent);
    color: #fff;
    cursor: pointer;
  }
}
/deep/ .el-textarea__inner {
  height: 100px;
}

.boxBig {
  width: 100%;
  height: 100%;
}
</style>
